<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :showExpand="false"
      :inRowBtnRead="true"
      :rowClickRead="true"
      :filterSelects="filterSelects"
      :liveSearching="true"
      :isMultiSelect="true"
      :filterProps="filterProps"
      @filter-select="$_onFilterSelect($event)"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/checklist_template";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "sequence",
      "name",
      "frequency",
      "areas",
      "system_classes",
      "last_version__updated_at",
      "last_version__updated_admin",
    ],
    sortBy: "sequence",
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "篩選地區",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        label: "",
        type: "hasMany",
        textKey: "name",
        modelName: "area_section",
        placeholder: "篩選子地區",
        hasNoSearch: true,
        hasAllSelectBtn: true,
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "multiple-layer-select",
        label: "",
        textKey: "name",
        modelName: "system_subclasses",
        getUrl: "system_class",
        placeholder: "篩選領域/子領域",
        orderBy: "sequence",
        orderWay: "asc",
      },
      {
        conditionKeys: [
          {
            fieldName: "area",
            conditionName: "area",
            type: "array",
          },
        ],
        requiredField: "area",
        type: "select",
        label: "",
        placeholder: "篩選頻率",
        textKey: "name",
        modelName: "frequency",
        items: [
          {
            text: "不限頻率",
            value: "",
          },
          {
            text: "日",
            value: "day",
          },
          {
            text: "週",
            value: "week",
          },
          {
            text: "月",
            value: "month",
          },
          {
            text: "季",
            value: "season",
          },
          {
            text: "年",
            value: "year",
          },
          {
            text: "每次作業",
            value: "everyTime",
          },
        ],
        defaultValue: "",
      },
      {
        type: "switch-tabs",
        label: "",
        textKey: "name",
        modelName: "status",
        defaultValue: "1",
        width: "72px",
        items: [
          {
            value: "1",
            text: "顯示",
          },
          {
            value: "0",
            text: "隱藏",
          },
          {
            value: "2",
            text: "修訂中",
          },
        ],
      },
      {
        type: "select",
        label: "",
        modelName: "range_type",
        placeholder: "篩選適用範圍類型",
        textKey: "name",
        items: [
          {
            text: "所有類型",
            value: "",
          },
          {
            text: "通用",
            value: "general",
          },
          {
            text: "專屬",
            value: "exclusive",
          },
        ],
        defaultValue: "",
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "exclusive_factories",
        placeholder: "篩選專屬工廠",
        textKey: "name",
        getText(item) {
          return this.$_CMS_getFactoryName(item)
        },
      },
      {
        type: "hasMany",
        label: "",
        modelName: "factory",
        paramName: "factories",
        placeholder: "篩選適用工廠",
        textKey: "name",
        getText(item) {
          return this.$_CMS_getFactoryName(item)
        },
      },
    ],
    filterProps: {},
  }),
  methods: {
    $_onFilterSelect($event) {
     if ($event && ($event.exclusive_factories || $event.factories)) {
        if (this.filterProps.range_type != $event.range_type) {
          if ($event.range_type === "exclusive") {
            this.filterProps = {
              ...$event,
              factories: null,
            };
          } else if ($event.range_type === "general") {
            this.filterProps = {
              ...$event,
              exclusive_factories: null,
            };
          } else if ($event.range_type === "") {
            this.filterProps = {
              ...$event,
              factories: null,
              exclusive_factories: null,
            };
          }
        } else {
          this.filterProps = {
            ...$event,
          };
        }
      } else {
        this.filterProps = {
            ...$event,
          };
      }
    },
  },
};
</script>

<style>
</style>